const DEFAULT_APP_URL = 'https://payroll-gpt.payrollmauritius.com';

export const SEO = {
  siteName: 'Payroll-GPT',
  defaultTitle: 'Payroll-GPT — Private AI for Payroll Mauritius',
  defaultDescription:
    'Sign in to Payroll-GPT, the private AI workspace for Payroll Mauritius. Ask payroll questions, generate reports, and automate workflows — securely scoped to your company.',
  loginTitle: 'Sign in to Payroll-GPT — Private AI for Payroll Mauritius',
  loginDescription:
    'Sign in with your Payroll Mauritius credentials to open Payroll-GPT. New to Payroll Mauritius? Register your company at payrollmauritius.com.',
  organizationUrl: 'https://payrollmauritius.com',
} as const;

/** Public app origin (no trailing slash). Used for canonical / OG URLs. */
export function getAppUrl(): string {
  const fromEnv =
    typeof import.meta.env.VITE_APP_URL === 'string' ? import.meta.env.VITE_APP_URL.trim() : '';
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return DEFAULT_APP_URL;
}

export function absoluteUrl(path: string): string {
  const base = getAppUrl();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}
